import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import classnames from "classnames";
import NotFoundIcon from "../../../theme/not_found.png";
import "../ErrorScreen.scss";
import styles from "./NotFound.scss";

const msgs = defineMessages({
  title: {
    id: "app.not_found.title",
    description: "Wow! How did you end up here?",
    defaultMessage: "Wow! How did you end up here?",
  },
  description: {
    id: "app.not_found.description",
    description: "Don’t worry, we will get you out.",
    defaultMessage: "Don’t worry, we will get you out.",
  },
  backHome: {
    id: "app.not_found.backHome",
    description: "Back home",
    defaultMessage: "Back home",
  },
});

function NotFound({ hotelSiteURL, handleBackButton }) {
  return (
    <div
      className={classnames("wbkv9-NotFound-wrapper", "wbkv9-ErrorScreen-wrapper", styles.wrapper)}>
      <div
        className={classnames(
          "wbkv9-NotFound-titleContainer",
          "wbkv9-ErrorScreen-titleContainer",
          "wbkv9-ErrorScreen-row",
          styles.titleContainer
        )}>
        <div
          className={classnames("wbkv9-NotFound-title", "wbkv9-ErrorScreen-title", styles.title)}>
          <div className={styles.number}>404</div>
          <FormattedMessage {...msgs.title} />
        </div>
      </div>

      <div
        className={classnames(
          "wbkv9-NotFound-mainImage",
          "wbkv9-ErrorScreen-mainImage",
          "wbkv9-ErrorScreen-row",
          styles.mainImage
        )}>
        <img src={NotFoundIcon} />
      </div>

      {hotelSiteURL && (
        <>
          <div
            className={classnames(
              "wbkv9-NotFound-description",
              "wbkv9-ErrorScreen-description",
              "wbkv9-ErrorScreen-row",
              styles.description
            )}>
            <FormattedMessage {...msgs.description} />
          </div>

          <div
            className={classnames(
              "wbkv9-NotFound-backButtonContainer",
              "wbkv9-ErrorScreen-backButtonContainer",
              "wbkv9-ErrorScreen-row",
              styles.backButtonContainer
            )}>
            <button
              className={classnames(
                "wbkv9-NotFound-backButton",
                "wbkv9-ErrorScreen-backButton",
                styles.backButton
              )}
              onClick={handleBackButton}>
              <FormattedMessage {...msgs.backHome} />
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default NotFound;
